import {defineMessages} from 'react-intl';

export default defineMessages({
	labelCountry: {
		id: 'countrySelector.labelCountry',
		defaultMessage: 'Country',
	},
	labelLanguage: {
		id: 'countrySelector.labelLanguage',
		defaultMessage: 'Language',
	},
	confirmButton: {
		id: 'countrySelector.confirmButton',
		defaultMessage: 'Confirm',
	},
	selectCountry: {
		id: 'countrySelector.selectCountry',
		defaultMessage: 'Country',
	},
	selectLanguage: {
		id: 'countrySelector.selectLanguage',
		defaultMessage: 'Language',
	},
});